
<app-cps-tab-bar context="document"></app-cps-tab-bar>

<div class="container-fluid">
    <div class="document-wrapper" [ngClass]="{ 'isTocSticky': isTocSticky }" #docWrapper>
        <ng-template appDocumentHost></ng-template>
    </div>
</div>
